let activeDeviceDid = "";

const normalizeDeviceDid = (value) => String(value ?? "").trim();

const isDeviceDetailsPage = () => {
  if (typeof window === "undefined") return false;
  return /\/devices\/details\/[^/]+\/?$/i.test(window.location?.pathname || "");
};

export const setActiveAiDeviceId = (deviceDid) => {
  activeDeviceDid = normalizeDeviceDid(deviceDid);
};

export const clearActiveAiDeviceId = (deviceDid) => {
  const normalized = normalizeDeviceDid(deviceDid);
  if (!normalized || activeDeviceDid === normalized) {
    activeDeviceDid = "";
  }
};

export const getActiveAiDeviceId = () =>
  isDeviceDetailsPage() ? activeDeviceDid : "";
